import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import apiClient from "../common/http.service";

export const useVariants = () => {
    const queryClient = useQueryClient();

    const variantsQuery = useQuery({
        queryKey: ["variants"],
        queryFn: async () => {
            const response = await apiClient.get("/variants");
            return response?.data?.data || [];
        },
    });

    const createMutation = useMutation({
        mutationFn: (data) => apiClient.post("/variants", data),
        onSuccess: () => {
            toast.success("Created successfully");
            queryClient.invalidateQueries({ queryKey: ["variants"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Create failed"),
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => apiClient.put(`/variants/${id}`, data),
        onSuccess: () => {
            toast.success("Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["variants"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Update failed"),
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => apiClient.delete(`/variants/${id}`),
        onSuccess: () => {
            toast.success("Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["variants"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Delete failed"),
    });

    return {
        variants: variantsQuery.data || [],
        isLoading: variantsQuery.isLoading,
        createVariant: createMutation.mutateAsync,
        updateVariant: updateMutation.mutateAsync,
        deleteVariant: deleteMutation.mutateAsync,
        isSaving: createMutation.isPending || updateMutation.isPending,
    };
};